export default {
    apiDomain:'http://api.yimo.link'
}


// WEBPACK FOOTER //
// ./src/config/index.prod.js